module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/modal//pb-bg.png?v=fd7e8117";